<template>
  <div class="details_box">
    <!-- 轉出/轉入記錄 -->
    <div class="deal_content_box" v-loading="inquireTF">
        <div class="deal_content_title">記錄詳情</div>
        <!-- 內容 -->
        <div class="deal_content">
          <!-- box -->
          <div class="content_box">
            <!-- 箭頭-box -->
            <!-- <p class="arrows_box">
              <span @click="detailsPN(previousId, branchType, previousBranchType)"><i class="el-icon-caret-left"></i>上一筆</span>
              <span @click="detailsPN(nextId, branchType, nextBranchType)">下一筆<i class="el-icon-caret-right"></i></span>
            </p> -->
            <!-- 箭頭-end -->
            <!-- 表單 -->
            <div class="table_box">
              <div>
                <p class="table_title">出款帳戶</p>
                <p class="table_content">{{this.$store.state.detailsList.doAccount}}</p>
              </div>
              <div>
                <p class="table_title">入款帳戶</p>
                <p class="table_content">{{this.$store.state.detailsList.inAccount}}</p>
              </div>
              <div>
                <p class="table_title">轉入/轉出單號</p>
                <p class="table_content">{{this.$store.state.detailsList.inOutOrder}}</p>
              </div>
  
              <div>
                <p class="table_title">發起時間</p>
                <p class="table_content">{{this.$store.state.detailsList.transaction_time}}</p>
              </div>
              <div>
                <p class="table_title">業務類型</p>
                <p class="table_content">{{this.$store.state.detailsList.type}}</p>
              </div>
              <div>
                <p class="table_title">金額（元）</p>
                <p class="table_content">{{this.$store.state.detailsList.money}}</p>
              </div>
              <div>
                <p class="table_title">狀態</p>
                <p class="table_content">{{this.$store.state.detailsList.status}}</p>
              </div>
              <div>
                <p class="table_title">操作人員</p>
                <p class="table_content">{{this.$store.state.detailsList.outAccount}}</p>
              </div>
              <div>
                <p class="table_title">操作備註</p>
                <p class="table_content">{{this.$store.state.detailsList.doContent}}</p>
              </div>
              <div>
                <p class="table_title">最後更新時間</p>
                <p class="table_content">{{this.$store.state.detailsList.lastTime}}</p>
              </div>
              <!-- <div>
                <p class="table_title">失敗原因</p>
                <p class="table_content">{{this.$store.state.detailsList.reason}}</p>
              </div> -->
            </div>
            <!-- 表單-end -->
            <!-- 按鈕-box -->
            <div class="button_box">
              <el-button type="primary" @click="detailsBack()">回上一頁</el-button>
            </div>
            <!-- 按鈕-end -->
          </div>
          <!-- box-end -->
        </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'OrderDetails',
  props: {
  },
  data() {
    return {
     inquireTF: false
    }
  },
  components: {
  },
  methods: {
    detailsBack(){
      this.$emit('detailsFun');

    },
    // FUN-上一筆/下一筆
    detailsPN(id, branch, type){
      this.inquireTF = true;
      axios.get(this.$store.state.axiosRecordDetailsUrl, {
          params: {
              id: id,
              uid: this.$store.state.uid
          }
      }).then((res) => {
          // console.log(res.data.message);
          this.inquireTF = false;
          this.$store.commit('changeDetails',res.data.message);
      })
    },
  },
  computed: {
    // nextBranchType(){
    //   return this.$store.state.detailsList.next_branch_type;
    // },
    // previousBranchType(){
    //   return this.$store.state.detailsList.previous_branch_type;
    // },
    // previousId(){
    //   return this.$store.state.detailsList.previous_page;
    // },
    // nextId(){
    //   return this.$store.state.detailsList.next_page;
    // },
    // branchType(){
    //   return this.$store.state.detailsList.wm_branch;
    // }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/* 内容 */
    .datetime_box > span {
      margin: 10px;
    }
    .deal_content_box {
      font-size: 13px;
      margin-top: 20px;
    }
    .deal_content_title {
      height: 42px;
      background: #666666;
      line-height: 42px; 
      color: white;
      padding-left: 14px;
    }
    .deal_content {
      color: #000000;
      box-sizing: border-box;
      border: 1px solid #666666;
      background: #ffffff;
      padding: 50px 66px;
    }

  /* 表格 */
  .content_box {
    /* width: 600px; */
  }
  .arrows_box {
    display: flex;
    justify-content: space-between;
  }
  .arrows_box > span {
    cursor: pointer;
  }
  .table_box {
      display: flex;
      flex-direction: column;
      margin-top: 20px;
  }
  .table_box > div {
    display: flex;
  }
  .table_box > div > p {
    border: 1px solid #e7e7e7;
    padding: 12px 0 12px 30px;
  }
  .table_box > div > p > span+span {
    margin-left: 55px;
  }
  .table_title {
    width: 180px;
  }
  .table_content {
    flex: 1;
  }
  .button_box {
    margin-top: 36px;
    display: flex;
    justify-content: flex-end;
  }
  .button_box .el-button {
    padding: 8px 20px;
  }
</style>
